import { number, shape, string, arrayOf, bool } from 'prop-types';

export const crdTypes = shape({
  crd: string,
  directShip: bool,
  po: string,
  purchaseMethod: string,
  sizes: arrayOf(
    shape({
      code: string,
      display: string,
      sortOrder: number,
      units: number
    })
  )
});

export const copyTypes = shape({
  description: string,
  language: string,
  name: string
});

export const imageTypes = shape({
  type: string.isRequired,
  url: string.isRequired,
  url_hr: string
});

export const priceTypes = shape({
  currency: string.isRequired,
  retail: number.isRequired,
  wholesale: number.isRequired
});

export const silhouetteTypes = shape({
  code: string,
  description: string
});

export const sizeTypes = shape({
  description: string,
  upc: string
});

export const teamTypes = shape({
  id: number,
  name: string
});

export const productTypes = shape({
  id: string,
  bodyType: string,
  bom: shape({
    colors: shape({
      primary: string
    })
  }),
  category: string,
  color: string,
  colorName: string,
  copy: copyTypes,
  division: string,
  images: arrayOf(imageTypes),
  offerDates: shape({
    endFuture: string,
    endProduct: string,
    firstProduct: string
  }),
  prices: arrayOf(priceTypes),
  productCode: string,

  region: string,
  season: string,
  segment: string,
  silhouette: silhouetteTypes,
  sizes: arrayOf(sizeTypes),
  styleGenderAge: string,
  team: teamTypes
});

export const cartProductTypes = shape({
  addedTimeStamp: string,
  cartId: string,
  crds: arrayOf(crdTypes),
  id: string,
  metaData: productTypes,
  name: string,
  retail: number,
  styleColor: string,
  totalUnits: number,
  wholesale: number
});

export const availabilityTypes = arrayOf(
  shape({
    availability: shape({
      sizes: arrayOf(
        shape({
          quantity: number,
          size: string
        })
      ),
      productCode: string
    })
  })
);

export const productAvailabilityTypes = shape({
  data: arrayOf(
    shape({
      availability: shape({
        sizes: arrayOf(
          shape({
            quantity: number,
            size: string
          })
        ),
        productCode: string
      })
    })
  )
});

export const purchaseOptionTypes = shape({
  amountBuy: string,
  amountFree: string,
  description: string,
  minimumUnitsRequired: string,
  purchaseOptionId: string,
  totalUnitsPurchased: string,
  unitAttributeName: string,
  unitAttributeValue: string
});

export const unitAllotmentTypes = shape({
  allotmentAmount: string,
  description: string,
  totalSpend: string,
  uniqueId: string,
  unitAttributeName: string,
  unitAttributeValue: string
});
